import CryptoJS from 'crypto-js';

//This function takes a string as an argument and transforms it into a substring taking the first to characters starting after the "/"
//The substring is checked for special characters and if found replaces them with a dash "-"
//It then adds to that substring a new sha256 encrypted string of 22 characters
export const sanitize = (key: string) =>
  key.substring(key.lastIndexOf('/') + 1, 2).replace(/[.$#[]\/]/g, '-') +
  CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(key, 'nIsrEpa0ukl'))
    .substr(0, 22)
    .replace(/\//g, '-');
